import { GeoJSON } from 'react-leaflet';
import React, { useCallback } from 'react';
import { mapDataKey } from '../../../utils/map/MapCalculations';
import { featureFilterUnselectedMarker, filterDepot } from '../../../utils/map/MapFeatureFilters';

const UnselectedMarkers = ({
  mapData,
  user,
  display,
  routingRoutes,
  makeMapMarkers,
  displayUnselected,
  highlightUnassigned,
}) => {
  const filterMarkersUnselectedFeatures = useCallback(
    (feature) => {
      return featureFilterUnselectedMarker(feature, display);
    },
    [display],
  );

  return (
    displayUnselected &&
    user.mapSettings.showStops && (
      <GeoJSON
        key={`${mapDataKey(
          mapData,
          user,
          display,
          routingRoutes,
          highlightUnassigned,
        )}-marker-unselected`}
        data={filterDepot(mapData, false)}
        pointToLayer={makeMapMarkers}
        filter={filterMarkersUnselectedFeatures}
      />
    )
  );
};

export default UnselectedMarkers;
